import { API, Auth } from 'aws-amplify';
import { push, replace } from 'connected-react-router';

import { handleUnauthorizedError } from '../../utils';
import { errorActions } from './errors';
import { layoutActions } from './layouts';
import { deliveryOptionsConstants } from './types';
import {getDefaultHeaders} from "../../utils/http";

export const deliveryOptionsActions = {
    updateState,
    getDeliveryOptions,
    createDeliveryOption,
    getDeliveryOption,
    updateDeliveryOption,
    removeDeliveryOption,
    toggleActive,
    resetDeliveryOption,
    duplicateDeliveryOption,
};

function updateState(name, value) {
    return { type: deliveryOptionsConstants.UPDATE_STATE, name, value };
}

function resetDeliveryOption() {
    return { type: deliveryOptionsConstants.RESET_DELIVERY_OPTION };
}

function getDeliveryOptions() {
    return dispatch => {
        dispatch(request());

        Auth.currentSession().then(currentSession => {
            API.get('delivery', '/admin', {})
                .then(response => {
                    response = response.map(x => {
                        x.price = x.price / 100;
                        return x;
                    });
                    return new Promise(resolve => {
                        resolve(response);
                    });
                })
                .then(response => dispatch(success(response)))
                .catch(error => {
                    handleUnauthorizedError(error);
                    dispatch(failure(error.response.data.error, dispatch));
                });
        });
    };

    function request() {
        return { type: deliveryOptionsConstants.LIST_REQUEST };
    }
    function success(deliveryOptions) {
        return { type: deliveryOptionsConstants.LIST_SUCCESS, deliveryOptions };
    }
    function failure(error, dispatch) {
        dispatch(layoutActions.displayErrorDialog('Error retrieving delivery options', error));
        return { type: deliveryOptionsConstants.LIST_FAIL, error };
    }
}

function createDeliveryOption(deliveryOption) {
    return dispatch => {
        dispatch(request(deliveryOption));
        dispatch(errorActions.clear());

        const service = {
            channel: deliveryOption.channel,
            store: deliveryOption.store,
        };

        const bodyData = { ...deliveryOption };
        bodyData.price = Number(deliveryOption.price) * 100;
        delete bodyData.channel;
        delete bodyData.store;

        Auth.currentSession().then(async currentSession => {
            const defaultHeaders = await getDefaultHeaders(currentSession);
            API.post('delivery', '/admin', {
                headers: {
                    ...defaultHeaders,
                    ...service,
                },
                body: {
                    ...bodyData,
                },
            })
                .then(response => {
                    dispatch(success(response, dispatch));
                })
                .catch(error => {
                    handleUnauthorizedError(error);
                    dispatch(failure(error.response.data.error, dispatch));
                    dispatch(errorActions.push(error.error));
                });
        });
    };

    function request(data) {
        return { type: deliveryOptionsConstants.CREATE_REQUEST, data };
    }
    function success(deliveryOption, dispatch) {
        dispatch(push(`/delivery/${deliveryOption.ID}`));
        return {
            type: deliveryOptionsConstants.CREATE_SUCCESS,
            deliveryOption,
        };
    }
    function failure(error, dispatch) {
        dispatch(layoutActions.displayErrorDialog('Error creating delivery', error));
        return { type: deliveryOptionsConstants.CREATE_FAIL, error };
    }
}

function getDeliveryOption(id) {
    return dispatch => {
        dispatch(request(id));
        dispatch(errorActions.clear());

        Auth.currentSession().then(currentSession => {
            API.get('delivery', `/admin/${id}`, {})
                .then(response => {
                    response.price = response.price / 100;
                    return new Promise(resolve => {
                        resolve(response);
                    });
                })
                .then(response => dispatch(success(response, dispatch)))
                .catch(error => {
                    handleUnauthorizedError(error);
                    dispatch(failure(error.response.data.error, dispatch));
                });
        });
    };

    function request(id) {
        return { type: deliveryOptionsConstants.GET_REQUEST, id };
    }
    function success(deliveryOption, dispatch) {
        return { type: deliveryOptionsConstants.GET_SUCCESS, deliveryOption };
    }
    function failure(error, dispatch) {
        dispatch(push(`/delivery`));
        dispatch(layoutActions.displayErrorDialog('Error getting delivery option', error));
        return { type: deliveryOptionsConstants.GET_FAIL, error };
    }
}

function updateDeliveryOption(deliveryOption) {
    return dispatch => {
        dispatch(request(deliveryOption));
        dispatch(errorActions.clear());
        const bodyData = { ...deliveryOption };
        bodyData.price = Number(deliveryOption.price) * 100;

        Auth.currentSession().then(currentSession => {
            API.put('delivery', `/admin/${deliveryOption.ID}`, {
                body: bodyData,
            })
                .then(response => {
                    dispatch(success(response, dispatch));
                })
                .catch(error => {
                    handleUnauthorizedError(error);
                    dispatch(failure(error.response.data.error, dispatch));
                    dispatch(errorActions.push(error.error));
                });
        });
    };

    function request(deliveryOption) {
        return { type: deliveryOptionsConstants.SAVE_REQUEST, deliveryOption };
    }
    function success(deliveryOption, dispatch) {
        dispatch(getDeliveryOption(deliveryOption.ID));
        return { type: deliveryOptionsConstants.SAVE_SUCCESS, deliveryOption };
    }
    function failure(error, dispatch) {
        dispatch(layoutActions.displayErrorDialog('Error updating delivery option', error));
        return { type: deliveryOptionsConstants.SAVE_FAIL, error };
    }
}

function removeDeliveryOption(deliveryOption) {
    return dispatch => {
        dispatch(request(deliveryOption));
        dispatch(errorActions.clear());

        Auth.currentSession().then(currentSession => {
            API.del('delivery', `/admin/${deliveryOption.ID}`, {})
                .then(response => {
                    dispatch(success(dispatch));
                })
                .catch(error => {
                    handleUnauthorizedError(error);
                    dispatch(failure(error.response.data.error, dispatch));
                });
        });
    };

    function request(deliveryOption) {
        return {
            type: deliveryOptionsConstants.DELETE_REQUEST,
            deliveryOption,
        };
    }
    function success(dispatch) {
        dispatch(push('/delivery'));
        return { type: deliveryOptionsConstants.DELETE_SUCCESS };
    }
    function failure(error, dispatch) {
        dispatch(layoutActions.displayErrorDialog('Error deleting delivery option', error));
        return { type: deliveryOptionsConstants.DELETE_FAIL, error };
    }
}

function toggleActive({ ID }) {
    return dispatch => {
        dispatch(request(ID));
        dispatch(errorActions.clear());

        Auth.currentSession().then(currentSession => {
            API.put('delivery', `/admin/${ID}/toggleactive`, {})
                .then(response => {
                    dispatch(success(response, dispatch));
                })
                .catch(error => {
                    handleUnauthorizedError(error);
                    dispatch(failure(error.response.data.error, dispatch));
                });
        });
    };

    function request(ID) {
        return {
            type: deliveryOptionsConstants.TOGGLE_ACTIVE_REQUEST,
            ID,
        };
    }
    function success(deliveryOption, dispatch) {
        dispatch(getDeliveryOptions());
        return {
            type: deliveryOptionsConstants.TOGGLE_ACTIVE_SUCCESS,
            deliveryOption,
        };
    }
    function failure(error, dispatch) {
        dispatch(layoutActions.displayErrorDialog('Error toggling delivery option', error));
        return { type: deliveryOptionsConstants.TOGGLE_ACTIVE_FAIL, error };
    }
}

function duplicateDeliveryOption({ ID }) {
    return dispatch => {
        dispatch(request(ID));
        dispatch(errorActions.clear());

        Auth.currentSession().then(currentSession => {
            API.post('delivery', `/admin/${ID}/duplicate`, {})
                .then(response => {
                    dispatch(success(response, dispatch));
                })
                .catch(error => {
                    handleUnauthorizedError(error);
                    dispatch(failure(error.response.data.error, dispatch));
                });
        });
    };

    function request(ID) {
        return {
            type: deliveryOptionsConstants.DUPLICATE_REQUEST,
            ID,
        };
    }
    function success(deliveryOption, dispatch) {
        dispatch(getDeliveryOption(deliveryOption.ID));
        dispatch(replace(`/delivery/${deliveryOption.ID}`));
        return {
            type: deliveryOptionsConstants.DUPLICATE_SUCCESS,
            deliveryOption,
        };
    }
    function failure(error, dispatch) {
        dispatch(layoutActions.displayErrorDialog('Error duplicating delivery option', error));
        return {
            type: deliveryOptionsConstants.DUPLICATE_FAIL,
            error,
        };
    }
}
